module.exports = __webpack_public_path__ + "static/logo_color-e8cd34476abe26853d9fa27bfc54db2c.png";